var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataOperator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.35,
    height: 19.634,
    viewBox: "0 0 18.35 19.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keyboard",
    transform: "translate(-12.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65325",
    "data-name": "Path 65325",
    d: "M19.428,12.535l-.14,1.32a.378.378,0,0,0,.376.417h3.992a.378.378,0,0,0,.376-.417l-.14-1.32h4.973a1.405,1.405,0,0,0,1.4-1.4V1.4a1.405,1.405,0,0,0-1.4-1.4H14.153a1.405,1.405,0,0,0-1.4,1.4v9.728a1.405,1.405,0,0,0,1.4,1.4Zm3.809.982H20.083l.1-.982h2.945ZM14.153.755H28.865a.649.649,0,0,1,.648.649V9.968H13.5V1.4A.649.649,0,0,1,14.153.755ZM13.5,11.132v-.409H29.513v.409a.649.649,0,0,1-.649.648H14.153A.649.649,0,0,1,13.5,11.132Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65326",
    "data-name": "Path 65326",
    d: "M54.494,295.992a.378.378,0,0,0,.012-.37l-.746-1.435a.378.378,0,0,0-.335-.2H40.871a.378.378,0,0,0-.335.2l-.746,1.435a.378.378,0,0,0,.335.552H54.171A.378.378,0,0,0,54.494,295.992Zm-13.747-.574.353-.68H53.2l.353.68Z",
    transform: "translate(-25.64 -279.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65327",
    "data-name": "Path 65327",
    d: "M304.424,350.982h-.6a1.588,1.588,0,0,0-1.586,1.586.378.378,0,0,0,.378.378h3.021a.378.378,0,0,0,.378-.378A1.588,1.588,0,0,0,304.424,350.982Zm-1.344,1.208a.832.832,0,0,1,.74-.453h.6a.832.832,0,0,1,.74.453Z",
    transform: "translate(-274.911 -333.312)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataOperator);
export default __webpack_public_path__ + "static/media/data-operator.ba14fce4ffd4e67dc86932786554e962.svg";
export { ForwardRef as ReactComponent };